import { render } from "./SaveEmployeeReport.vue?vue&type=template&id=f66184da&scoped=true"
import script from "./SaveEmployeeReport.vue?vue&type=script&lang=js"
export * from "./SaveEmployeeReport.vue?vue&type=script&lang=js"

import "./employee-report.scss?vue&type=style&index=0&id=f66184da&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66184da"]])

export default __exports__